import React from 'react'
import { GridColumns } from '@mui/x-data-grid'
import { Box, Container } from '@mui/material'
import { translate as t } from '../../../i18n'
import { Avatar } from 'components/Avatar'

export const ColumnsToCopy: GridColumns = [
  {
    field: 'name',
    renderHeader: () => (t('training.gridColumns.label')),
    flex: 2,
    valueGetter: (params) => params.row.athlete.name,
    renderCell: (params) => {
      return <Container sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Avatar imagePath={params?.row?.athlete.imagePath} name={params.row?.athlete.name} />
        <Box sx={{ display: 'flex', flexDirection: 'column', paddingLeft: 1, textAlign: 'left' }}>
          <span style={{ fontWeight: 'bold' }}>{params?.row?.athlete.name} {params?.row?.athlete.surname}</span>
        </Box>
      </Container>
    }
  },
  {
    field: 'email',
    renderHeader: () => (t('training.gridColumns.email')),
    valueGetter: (params) => t(`${params.row.athlete.email}`),
    flex: 2
  }
]
